import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type InterventionState } from '../apis/interventions/intervention.type';

interface WorkshopState {
  workshopInterventionStates: InterventionState[];
}

interface WorkshopInterventionState {
  workshopInterventionStates: InterventionState[];
}

const initialState: WorkshopInterventionState = {
  workshopInterventionStates: [],
};

const workshopInterventionSlice = createSlice({
  name: 'workshopIntervention',
  initialState,
  extraReducers: builder => builder.addCase('resetStore', () => initialState),
  reducers: {
    initWorkshopState: (state, action: PayloadAction<WorkshopState>) => {
      state.workshopInterventionStates = action.payload.workshopInterventionStates;
    },
  },
});

export const {
  reducer: workshopInterventionReducer,
  actions: { initWorkshopState },
} = workshopInterventionSlice;
